/**
 *
 * Dynamic Form
 *
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Card,
  CardBody,
  CardHeader,
  CardText,
  Col,
  Row,
  //  Alert
} from "reactstrap"
import { ImplementationFor } from "./utils"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import ButtonSpinner from "components/ButtonSpinner"
import SimpleBar from "simplebar-react"
// import { isEmpty } from 'lodash'

function DynamicForm(props) {
  const {
    fields = [],
    onCancel,
    menuPlacement,
    onSubmit,
    initialValues = {},
    onChange,
    metaData,
    formTitle,
    submitButton,
    submitBtnText,
    // resetButton,
    // resetBtnText,
    // onReset,
    // resetButtonShow,
    title,
    formatterStyle,
  } = props

  const [validation, setValidation] = useState(false)
  console.log(validation, "validation")
  var validationSchemaJson = {}
  if (fields) {
    fields.forEach((item) => {
      //Mobile Validation
      if (item.required && item.validations && item.validations == "mobile") {
        validationSchemaJson[item.value] = Yup.string()
          .required(`${item.label} is required`)
          .matches(/^[0-9]+$/, `${item.label} Must be only digits`)
          .max(10, `${item.label} Must be exactly 10 digits`)
      }
      // Text Only
      else if (
        item.required &&
        item.validations &&
        item.validations == "textOnly"
      ) {
        validationSchemaJson[item.value] = Yup.string()
          .required(`${item.label} is required`)
          .matches(/^[aA-zZ\s]+$/, `${item.label} Only alphabets are allowed`)
      }
      // Zip code
      else if (
        item.required &&
        item.validations &&
        item.validations == "zipCode"
      ) {
        validationSchemaJson[item.value] = Yup.string()
          .required(`${item.label} is required`)
          .matches(/^[0-9]+$/, `${item.label} Must be only digits`)
          .max(6, `${item.label} Must be exactly 6 digits`)
      } else if (item.validations && item.validations == "arrayField") {
        validationSchemaJson[item.value] = Yup.array()
          .min(1, `${item.label} is required`)
          .required(`${item.label} is required`)
      } else if (item.required) {
        validationSchemaJson[item.value] = Yup.string().required(
          `${item.label} is required`
        )
      }
    })
  }
  return (
    <React.Fragment>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={Yup.object().shape(validationSchemaJson)}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values, setSubmitting, onCancel)
        }}
        // onReset={(values) => {
        //   onReset(values)
        // }}
      >
        {({
          values,
          errors,
          handleSubmit,
          // handleReset,
          setFieldValue,
          isSubmitting,
          touched,
          setFieldTouched,
          setSubmitting,
        }) => (
          <Form onSubmit={handleSubmit} className="form-horizontal">
            <div className="simple-right-bar" style={formatterStyle}>
              <SimpleBar>
                <div
                  className="modal-header simple-modal-header"
                  style={{
                    borderBottom: "1px solid #e3e3e3",
                  }}
                >
                  <h5
                    style={{ textTransform: "uppercase" }}
                    className="mx-3 modal-title mt-0"
                    id="myModalLabel"
                  >
                    {title}
                  </h5>
                  <button
                    type="button"
                    onClick={onCancel}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times</span>
                  </button>
                </div>
                <div className="modal-body simple-modal-body">
                  <Row className="simple-form-row">
                    <Card>
                      <CardHeader className="h5 bg-transparent card-input-header text-uppercase">
                        {formTitle || ""}
                      </CardHeader>
                      <CardBody>
                        <CardText
                          style={{
                            display: "flex",
                            marginRight: "-15px",
                            flexWrap: "wrap",
                            marginBottom: "6px",
                          }}
                        >
                          {(fields || []).map((field, index) => {
                            const InputComponent = ImplementationFor[field.type]
                            return (
                              <Col
                                key={index}
                                className="mb-3"
                                item
                                xs={12}
                                {...(field.colProps || {})}
                              >
                                <InputComponent
                                  {...field}
                                  name={field.value}
                                  menuPlacement={menuPlacement}
                                  value={
                                    field.type === "code" &&
                                    !values[field.value]
                                      ? field.autofillValue
                                      : values[field.value]
                                  }
                                  isInvalid={
                                    errors[field.value] && touched[field.value]
                                      ? errors[field.value]
                                      : null
                                  }
                                  metaData={metaData}
                                  setFieldValue={setFieldValue}
                                  touched={touched[field.value]}
                                  onChange={(e) => {
                                    setFieldTouched(field.value)
                                    setFieldValue(
                                      field.value,
                                      field.type === "select" ||
                                        field.type === "selectAll" ||
                                        field.type === "filterSelect" ||
                                        field.type === "multiSelect" ||
                                        field.type === "filterMultiSelect" ||
                                        field.type === "employeeMultiSelect" ||
                                        field.type === "autocomplete"
                                        ? e.value
                                        : (field.type === "checkbox" &&
                                            field.name != "permission") ||
                                          field.type === "hrmsCheckbox" ||
                                          field.type === "checkbox"
                                        ? e.target.checked
                                        : field.type === "number"
                                        ? e.target.value.replace(/\D/g, "")
                                        : e.target.value
                                    )
                                    if (onChange)
                                      onChange(
                                        Object.assign({}, values, {
                                          [field.value]:
                                            field.type === "select" ||
                                            field.type === "selectAll" ||
                                            field.type === "filterSelect" ||
                                            field.type === "multiSelect" ||
                                            field.type ===
                                              "filterMultiSelect" ||
                                            field.type ===
                                              "employeeMultiSelect" ||
                                            field.type === "autocomplete"
                                              ? e.value
                                              : (field.type === "checkbox" &&
                                                  field.type ===
                                                    "customTable") ||
                                                field.type === "hrmsCheckbox" ||
                                                field.type === "checkbox"
                                              ? e.target.checked
                                              : field.type === "number"
                                              ? e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                )
                                              : e.target.value,
                                        })
                                      )
                                  }}
                                />
                                {/* {validation ?  */}
                                <div
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                >
                                  {errors[field.value] || touched[field.value]
                                    ? errors[field.value]
                                    : null}
                                </div>
                                {/* // : ""} */}
                              </Col>
                            )
                          })}
                        </CardText>
                      </CardBody>
                    </Card>
                  </Row>
                </div>
                <div
                  style={{
                    borderTop: "1px solid #e3e3e3",
                  }}
                  className="modal-footer simple-modal-footer mt-2"
                >
                  {onCancel && typeof onCancel === "function" ? (
                    <button
                      onClick={() => {
                        onCancel()
                        setSubmitting(false)
                        setValidation(false)
                      }}
                      type="button"
                      className="btn btn-danger btn-label simple-form-cancel-btn"
                    >
                      <i className="bx bx-block label-icon "></i>Cancel
                    </button>
                  ) : null}
                  {/* {resetButtonShow == true
                    ? (resetButton &&
                        React.createElement(
                          resetButton,
                          Object.assign({}, props, {
                            values,
                            setFieldValue,
                            handleReset,
                            resetBtnText,
                          })
                        )) || (
                        <button
                          type="button"
                          onClick={() => {
                            setFieldValue({})
                          }}
                          className="btn btn-danger btn-label simple-form-submit-btn"
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          {resetBtnText || "Reset"}
                        </button>
                      )
                    : ""} */}
                  {(submitButton &&
                    React.createElement(
                      submitButton,
                      Object.assign({}, props, {
                        values,
                        setFieldValue,
                        handleSubmit,
                        submitBtnText,
                        isSubmitting,
                      })
                    )) || (
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      onClick={() => {
                        // setSubmitting(false)
                        setValidation(true)
                      }}
                      className="btn btn-success btn-label mx-1 simple-form-submit-btn"
                    >
                      <i className="bx bx-check-double label-icon"></i>
                      {isSubmitting ? (
                        <ButtonSpinner />
                      ) : (
                        submitBtnText || "Submit"
                      )}
                    </button>
                  )}
                </div>
              </SimpleBar>
            </div>
            <div className="simple-right-bar-overlay" />
          </Form>
        )}
      </Formik>
    </React.Fragment>
  )
}

DynamicForm.propTypes = {
  t: PropTypes.any,
  fields: PropTypes.array,
  onCancel: PropTypes.func,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  // onReset: PropTypes.func,
  error: PropTypes.any,
  metaData: PropTypes.object,
  formTitle: PropTypes.string,
  submitBtnText: PropTypes.string,
  // resetBtnText: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func,
  menuPlacement: PropTypes.any,
  formatterStyle: PropTypes.object,
  submitButton: PropTypes.func,
  // resetButton: PropTypes.func,
  // resetButtonShow: PropTypes.func,
}

export default DynamicForm
